import { render, staticRenderFns } from "./CompanyManager.vue?vue&type=template&id=21bcb5ec&"
import script from "./CompanyManager.vue?vue&type=script&lang=ts&"
export * from "./CompanyManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports